import {React, useState} from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

function ColorPicker(props){

  const [displayColorPicker, setDisplayColorPicker]  =     useState(false);
  const [color, setColor]  =     useState(props.formik.values.client?.client_branding_attributes?.primary_color_hex||'');

 const handleClick = () => {
     setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  }

  const handleChange = (color) => {
    setColor(color.hex);
    props.formik.setFieldValue(props.fieldName, color.hex);
  }

  const styles = reactCSS({
    'default': {
      color: {
        width: '22px',
        height: '22px',
        border: `1px solid ${color }`,
        borderRadius: '4px',
        background: `${color}`,
      },

      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  });

  
   return (
     <>
   <div style={ styles.swatch } onClick={handleClick } className={`Dpflex colorpickerpostion`}>
      <div style={ styles.color } />
      <div className={`ml15`}>   {color }</div>
    </div>
{ displayColorPicker ? <div style={ styles.popover }>
      <div style={ styles.cover } onClick={handleClose }/>
      <SketchPicker color={color} onChange={handleChange } />
    </div> : null
  }
  </>
   );
}
export default ColorPicker;




